/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { fetchCalculationMethod, saveCalculationMethod } from '../../actions/calculation-methods';
import { resetError } from '../../actions/errors';
import PinModal from '../../components/pin';

class CalculationMethodEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.failedSubmit = this.failedSubmit.bind(this);
  }

  componentWillMount() {
    const { getCalculationMethod } = this.props;
    getCalculationMethod();
  }

  handleChange(e, name) {
    const { value } = e.target;
    this.setState({ [name]: value });
  }

  requestSubmit(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedSubmit() {
    this.setState({
      submitted: false,
    });
  }

  handleSubmit() {
    const { saveCalculationMethodAction, goToShow, resetErrorAction } = this.props;
    resetErrorAction();
    const {
      name,
      name_ar,
      code,
      fajr_angle,
      isha_angle,
      manualAdjustmentFajr,
      manualAdjustmentSunrise,
      manualAdjustmentDhuhr,
      manualAdjustmentAsr,
      manualAdjustmentMaghrib,
      manualAdjustmentIsha,
      version,
    } = this.state;
    if (name === '') {
      goToShow();
      return;
    }
    const body = {
      name,
      name_ar,
      code,
      fajr_angle,
      isha_angle,
      manualAdjustmentFajr,
      manualAdjustmentSunrise,
      manualAdjustmentDhuhr,
      manualAdjustmentAsr,
      manualAdjustmentMaghrib,
      manualAdjustmentIsha,
      version,
    };
    Object.keys(body).forEach(key => body[key] === undefined && delete body[key]);
    const { calculationMethod } = this.props;
    saveCalculationMethodAction(
      calculationMethod.id,
      { body: JSON.stringify(body) },
    ).then(() => goToShow());
  }

  render() {
    const { calculationMethod } = this.props;
    const {
      name,
      name_ar,
      code,
      fajr_angle,
      isha_angle,
      manualAdjustmentFajr,
      manualAdjustmentSunrise,
      manualAdjustmentDhuhr,
      manualAdjustmentAsr,
      manualAdjustmentMaghrib,
      manualAdjustmentIsha,
      version,
      submitted,
    } = this.state;
    if (!calculationMethod || Object.keys(calculationMethod).length === 0) {
      return (null);
    }
    return (
      <div className="animated fadeIn">
        {
          submitted
          && <PinModal successSubmit={this.handleSubmit} failedSubmit={this.failedSubmit} />
        }
        <Row>
          <Col lg={8}>
            <Card>
              <Form onSubmit={e => this.requestSubmit(e)}>
                <CardHeader>
                  <strong>
                    {'Edit Calculation Method: '}
                    {calculationMethod.id}
                  </strong>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label htmlFor="name">Calculation Method Name</Label>
                    <Input
                      id="name"
                      type="text"
                      placeholder="Enter Calculation Method Name"
                      defaultValue={calculationMethod.name}
                      invalid={submitted && name === ''}
                      onChange={e => this.handleChange(e, 'name')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="name_ar">Calculation Method Name Arabic</Label>
                    <Input
                      id="name_ar"
                      type="text"
                      placeholder="Enter Calculation Method Name Arabic"
                      defaultValue={calculationMethod.name_ar}
                      invalid={submitted && name_ar === ''}
                      onChange={e => this.handleChange(e, 'name_ar')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="code">Code</Label>
                    <Input
                      id="code"
                      type="text"
                      placeholder="Enter Code"
                      defaultValue={calculationMethod.code}
                      invalid={submitted && code === ''}
                      onChange={e => this.handleChange(e, 'code')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="fajr_angle">Fajr Angle</Label>
                    <Input
                      id="fajr_angle"
                      type="text"
                      placeholder="Enter Fajr Angle"
                      invalid={submitted && fajr_angle === ''}
                      defaultValue={calculationMethod.fajr_angle}
                      onChange={e => this.handleChange(e, 'fajr_angle')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="isha_angle">Isha Angle</Label>
                    <Input
                      id="isha_angle"
                      type="text"
                      placeholder="Enter Isha Angle"
                      invalid={submitted && isha_angle === ''}
                      defaultValue={calculationMethod.isha_angle}
                      onChange={e => this.handleChange(e, 'isha_angle')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="manualAdjustmentFajr">Manual Adjustment Fajr</Label>
                    <Input
                      id="manualAdjustmentFajr"
                      type="text"
                      placeholder="Enter Manual Adjustment Fajr"
                      invalid={submitted && manualAdjustmentFajr === ''}
                      defaultValue={calculationMethod.manualAdjustmentFajr}
                      onChange={e => this.handleChange(e, 'manualAdjustmentFajr')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="manualAdjustmentSunrise">Manual Adjustment Sunrise</Label>
                    <Input
                      id="manualAdjustmentSunrise"
                      type="text"
                      placeholder="Enter Manual Adjustment Sunrise"
                      invalid={submitted && manualAdjustmentSunrise === ''}
                      defaultValue={calculationMethod.manualAdjustmentSunrise}
                      onChange={e => this.handleChange(e, 'manualAdjustmentSunrise')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="manualAdjustmentDhuhr">Manual Adjustment Dhuhr</Label>
                    <Input
                      id="manualAdjustmentDhuhr"
                      type="text"
                      placeholder="Enter Manual Adjustment Dhuhr"
                      invalid={submitted && manualAdjustmentDhuhr === ''}
                      defaultValue={calculationMethod.manualAdjustmentDhuhr}
                      onChange={e => this.handleChange(e, 'manualAdjustmentDhuhr')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="manualAdjustmentAsr">Manual Adjustment Asr</Label>
                    <Input
                      id="manualAdjustmentAsr"
                      type="text"
                      placeholder="Enter Manual Adjustment Asr"
                      invalid={submitted && manualAdjustmentAsr === ''}
                      defaultValue={calculationMethod.manualAdjustmentAsr}
                      onChange={e => this.handleChange(e, 'manualAdjustmentAsr')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="manualAdjustmentMaghrib">Manual Adjustment Mahrib</Label>
                    <Input
                      id="manualAdjustmentMaghrib"
                      type="text"
                      placeholder="Enter Manual Adjustment Mahrib"
                      invalid={submitted && manualAdjustmentMaghrib === ''}
                      defaultValue={calculationMethod.manualAdjustmentMaghrib}
                      onChange={e => this.handleChange(e, 'manualAdjustmentMaghrib')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="manualAdjustmentIsha">Manual Adjustment Isha</Label>
                    <Input
                      id="manualAdjustmentIsha"
                      type="text"
                      placeholder="Enter Manual Adjustment Isha"
                      invalid={submitted && manualAdjustmentIsha === ''}
                      defaultValue={calculationMethod.manualAdjustmentIsha}
                      onChange={e => this.handleChange(e, 'manualAdjustmentIsha')}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="version">Version</Label>
                    <Input
                      id="version"
                      type="number"
                      placeholder="Enter Version"
                      defaultValue={calculationMethod.version}
                      invalid={submitted && version === ''}
                      onChange={e => this.handleChange(e, 'version')}
                      required
                    />
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="success">Save</Button>
                  {' '}
                  <Button href={`/#/calculation-methods/${calculationMethod.id}`} size="sm" color="danger">Cancel</Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

CalculationMethodEdit.propTypes = {
  getCalculationMethod: PropTypes.func.isRequired,
  goToShow: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
  saveCalculationMethodAction: PropTypes.func.isRequired,
  calculationMethod: PropTypes.shape.isRequired,
};

const mapStateToProps = ({ calculationMethods }) => ({
  calculationMethod: calculationMethods.item,
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  getCalculationMethod: () => fetchCalculationMethod(ownProps.match.params.id),
  goToShow: () => push(`/calculation-methods/${ownProps.match.params.id}`),
  resetErrorAction: () => resetError(),
  saveCalculationMethodAction: (id, body) => saveCalculationMethod(id, body),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CalculationMethodEdit);
